import { useContext } from "react";
import { PropTypes } from "prop-types";

import { DiscountContext } from "../../context/DiscountProvider";

import useDeviceDetect from "../../hooks/useDeviceDetect";
import { useLocalizedSentenceDict } from "../../hooks/useSentenceDict";
import { cn } from "@helpers/general";

import { Popup } from "../Popup";
import { ALLink as Link } from "../ALComponents";
import DISCOUNT_TYPES from "../../constants/DiscountTypes";
import ShippingInformation from "./announcementBarPopup/ShippingInformation";
import ShippingDeadlines from "./announcementBarPopup/ShippingDeadlines";

import IconClose from "../icons/svgs/close.svg";

function AnnouncementBarPopup({ open, onClose, backgroundColor, popup }) {
  const { discountInfo } = useContext(DiscountContext);
  const { isMobile } = useDeviceDetect();
  const dict = useLocalizedSentenceDict();

  const { textColor, title, backgroundImage } = popup;

  if (!discountInfo) {
    return null;
  }

  return (
    <Popup className="popup_ab" open={open} onClose={onClose}>
      <div style={{ backgroundColor, color: textColor }} data-testid="ab-popup">
        <button
          onClick={onClose}
          className="absolute cursor-pointer top-0 right-0 p-[15px] border-0 bg-transparent"
          type="button"
          data-testid="close-button"
        >
          <IconClose width="30" fill={textColor} />
        </button>
        <div
          className={cn(
            backgroundImage?.title !== "empty" ? "p-0" : "px-[50px] pt-[47px] pb-[40px]"
          )}
        >
          {backgroundImage?.title !== "empty" && (
            <div className="flex justify-center">
              <img src={backgroundImage?.url} alt={backgroundImage?.title} />
              <Link
                className="al_p--bold absolute bottom-[50px] left-[40px] desktop:left-[55px]"
                to="/pages/promo-sale"
                style={{ color: textColor }}
                onClick={onClose}
              >
                <u>{dict.get("Exclusions Apply")}</u>
              </Link>
            </div>
          )}

          {backgroundImage?.title === "empty" && (
            <>
              <h2 className="al_h4 m-0 mb-[20px]">{title ? `${dict.get(title)}` : ""}</h2>

              {(discountInfo.type === DISCOUNT_TYPES.AMOUNT_PERCENT ||
                discountInfo.type === DISCOUNT_TYPES.QUANTITY_PERCENT) &&
                discountInfo.discounts?.map((discount, index) => {
                  const isLastItem = index === discountInfo.discounts?.length - 1;
                  return (
                    <div className="al_h1" key={`promo_${index}`}>
                      {isMobile
                        ? `${discount[1]}% off ${discount[0]}${isLastItem ? "+" : ""} item${
                            discount[0] > 1 ? "s" : ""
                          }${isLastItem ? "" : ","}`
                        : dict.get(
                            "Buy {0}, get {1}% off",
                            `${discount[0]}${isLastItem ? "+" : ""}`,
                            discount[1]
                          )}
                    </div>
                  );
                })}

              <ShippingDeadlines popup={popup} />

              <ShippingInformation textColor={textColor} />

              <p className="al_p">
                {dict.get(
                  "Code automatically applied at checkout. Limited-time online sale. Conditions apply."
                )}
                <Link
                  className="al_p--bold"
                  to="/pages/promo-sale"
                  style={{ color: textColor }}
                  onClick={onClose}
                >
                  <u>{dict.get("Read more")}</u>
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </Popup>
  );
}

AnnouncementBarPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  backgroundColor: PropTypes.string,
  popup: PropTypes.shape({
    textColor: PropTypes.string,
    title: PropTypes.string,
    backgroundImage: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    deadlines: PropTypes.shape(),
  }),
};

export default AnnouncementBarPopup;
